import { createEvent } from 'effector'

type OpenCasePageProps = {
  id: number
  type: number
  name: string
  description: string
  onPrewiew: boolean
}

export const openCasePage = createEvent<OpenCasePageProps>()
export const setCaseId = createEvent<number>()
export const setOpenedLbKind = createEvent<boolean>()

export const triggerKeysRefetch = createEvent<string>()
